import type CurrencyCode from '@alltrails/types/CurrencyCode';
import { getPurchaseEventId, getTrialStartEventId, getSignupEventId } from './conversionsApi';

export const trackPurchaseForReddit = ({
  userId,
  currencyCode,
  value,
  isTrial,
  subscription_event_id
}: {
  userId: number;
  currencyCode: CurrencyCode;
  value: number;
  isTrial: boolean;
  subscription_event_id?: number;
}) => {
  if (isRedditPixelUnavailable() || !subscription_event_id) {
    return;
  }

  if (isTrial) {
    rdt('track', 'TrialStart', {
      conversionId: getTrialStartEventId(subscription_event_id),
      externalId: userId
    });
  } else {
    rdt('track', 'Purchase', {
      currency: currencyCode,
      value,
      conversionId: getPurchaseEventId(subscription_event_id),
      externalId: userId
    });
  }
};

export const trackCompleteRegistrationForReddit = (userId: number) => {
  if (isRedditPixelUnavailable()) {
    return;
  }

  rdt('track', 'SignUp', { conversionId: getSignupEventId(userId), externalId: userId });
};

// Check for presence of rdt in case of content blockers
const isRedditPixelUnavailable = () => {
  return typeof rdt === 'undefined';
};
